import React, { useEffect, useState } from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import Image from "../components/image";
import SEO from "../components/seo";
import styled from "styled-components";
/* import Autocomplete from "react-autocomplete"; */
import * as JsSearch from "js-search";
import "./index.css";
 import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "none"
    },
    "&&:after": {
      borderBottom: "none"
    }
  }
});

const Input = styled.input`
  font-size: 18px;
  padding: 5px;
  margin: 10px;
  border: 0px solid #000;
  border-radius: 3px;
  :hover {
    border: 0px solid #000;
  }
  :active {
    border: 0px solid #000;
  }
  :focus-visible {
    border: 0px solid #000;
    outline: none;
  }
`;
const Span = styled.span`
  border-left: 1px solid #cccccc;
  padding-left: 10px;

  @media (max-width: 400px) {
    border-left: 0px solid #cccccc;
    padding-left: 0px;
  }
`;

function Component({ query }) {
  console.log({ query });
  let search = new JsSearch.Search("brandName");
  search.addIndex("state");
  search.addIndex("concept");
  search.addIndex("cuisine");
  search.addIndex("brandName");
  let search2 = new JsSearch.Search("brandName");
  search2.addIndex("state");
  search2.addIndex("concept");
  search2.addIndex("cuisine");
  search2.addIndex("brandName");
  const [list, setList] = useState([]);
  const [cussionSuggestions, setCussionSuggestions] = useState([]);
  const [cussionSuggestions1, setCussionSuggestions1] = useState([]);
  const [suggestions, setSggestions] = useState([]);
  const [suggestions1, setSggestions1] = useState([]);
  const [state, setState] = useState("");
  const [location, setLocation] = useState("");

  useEffect(() => {
    setList([...query]);
    let arr = [];
    let cuisine = [];
    let q = [...query];
    query.forEach((element, index) => {
      let locationsArr = [];
      let arr1 = [];
      let arr2 = [];
      element.concepts.forEach((element2) => {
        arr1.push(element2?.title);
        cuisine.push(element2?.title);
      });
      element.cuisines.forEach((element2) => {
        arr2.push(element2?.name);
        cuisine.push(element2?.name);
      });
      element.locations.forEach((element2) => {
        arr.push(element2?.location?.city);
        if (element2?.location?.city) {
          locationsArr.push(element2?.location?.city);
        }
      });
      q[index]["state"] = [...locationsArr];
      q[index]["cuisine"] = [...arr2];
      q[index]["concept"] = [...arr1];
    });
    console.log(q);

    search.addDocuments(q);

    let unique = arr.filter((item, i, ar) => ar.indexOf(item) === i);
    let unique2 = cuisine.filter((item, i, ar) => ar.indexOf(item) === i);

    console.log(unique, "unique")

    setSggestions([...unique]);
    setSggestions1([...unique]);
    setCussionSuggestions1([...unique2]);
    setCussionSuggestions([...unique2]);
  }, []);

  const handleSearch = () => {

    console.log("clicked")
    let arr = [];

    let q = [...query];
    query.forEach((element, index) => {
      let locationsArr = [];
      let arr1 = [];
      let arr2 = [];
      element.concepts.forEach((element2) => {
        arr1.push(element2?.title);
      });
      element.cuisines.forEach((element2) => {
        arr2.push(element2?.name);
      });
      element.locations.forEach((element2) => {
        arr.push(element2?.location?.city);
        if (element2?.location?.city) {
          locationsArr.push(element2?.location?.city);
        }
      });
      q[index]["state"] = [...locationsArr];
      q[index]["cuisine"] = [...arr2];
      q[index]["concept"] = [...arr1];

      console.log(arr1, "concepts")
      console.log(arr2, "cuisine")
      console.log(locationsArr, "locationsArr")
    });


    search.addDocuments(q);
    if (state && state !== null && state !== "") {
      let arrr = search.search(state);
      if (location && location !== null && location !== "") {
        search2.addDocuments(arrr);
        let arrr2 = search2.search(location);
        setList([...arrr2]);
      } else {
        setList([...arrr]);
      }
    } else if (location && location !== null && location !== "") {
      let arrr = search.search(location);
      console.log(arrr, "arrrrrrrrrr")
      setList([...arrr]);
    } else {
      setList([...query]);
    }
  };
  const handleSelect = (val) => {
    setLocation(val);
  };
  const handleChange = (val) => {
    console.log(val,"*********************")
    try {
      let s = [...suggestions1];
    /*   setSggestions([
        ...s.filter((i) => i?.toString()?.toLowerCase()?.includes(val?.toLowerCase())),
      ]); */
      setLocation(val);
    } catch (e) {
      console.log(e);
    }

  };
  const handleSelect1 = (val) => {
    setState(val);
  };
  const handleChange1 = (val) => {


    try {
      let s = [...cussionSuggestions1];
      console.log(val, "******");
       /*  setCussionSuggestions([
        ...s.filter((i) =>
          i?.toString()?.toLowerCase()?.includes(val?.toLowerCase())),
      ]); */

      setState(val);
    } catch (e) {
      console.log(e);
    }

  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };




  return (
    <div>
      <div className="grid-container1">
        <div
          style={{
            display: "inline",
            border: "1px solid #CCCCCC",
            borderRadius: "5px",
            borderTopRightRadius: "0px",
            borderBottomRightRadius: "0px",
            padding: "0px 5px 0px 15px",
          }}
          className="grid-container auto-complete"
        >
          <div
            class="find"
            style={{
              float: "left",
              width: "50%",
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={cussionSuggestions}
              value={state}
              onChange={(e, val) => handleChange1(val)}
              filterSelectedOptions
              getOptionLabel={(option) => option}
              class="auto1"
              sx={{ width: 250 }}
              clearOnEscape={true}
              renderInput={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                    zIndex: 1,
                    width: "80%",
                    textAlign: "left",
                  }}
                >
                  <TextField
                    {...item}
                    label="Find"
                    variant="standard"
                    class="textfield"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              )}
            />
          </div>

          <div
            class="near"
            style={{
              float: "right",
              width: "50%",
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={suggestions}
              value={location}
              clearOnEscape={true}
              getOptionLabel={(option) => option}
              filterSelectedOptions
              onChange={(e, val) => handleChange(val)}
              class="auto2"
              sx={{ width: 250 }}
              renderInput={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                    zIndex: 1,
                    width: "80%",
                    textAlign: "left",
                  }}
                >
                  <TextField
                    {...item}
                    label="Near"
                    variant="standard"
                    class="textfield"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              )}
            />
          </div>

          {/*  <Autocomplete
            getItemValue={(item) => item}
            items={cussionSuggestions}
            renderItem={(item, isHighlighted) => (
              <div
                style={{
                  background: isHighlighted ? "lightgray" : "white",
                  zIndex: 1,
                  textAlign: "left",
                  paddingLeft: "7px",
                }}
              >
                {item}
              </div>
            )}
            className="auto"
            value={state}
            onChange={(e) => handleChange1(e.target.value)}
            onSelect={(val) => handleSelect1(val)}
          /> */}
          {/*  <Input type="text" value={state} onChange={handleChangeState} /> */}

          {/*  <Autocomplete
            getItemValue={(item) => item}
            items={suggestions}
            renderItem={(item, isHighlighted) => (
              <div
                style={{
                  background: isHighlighted ? "lightgray" : "white",
                  zIndex: 1,

                  textAlign: "left",
                  paddingLeft: "7px",
                }}
              >
                {item}
              </div>
            )}
            className="auto"
            value={location}
            onChange={(e) => handleChange(e.target.value)}
            onSelect={(val) => handleSelect(val)}
          /> */}
        </div>

        <span
          style={{
            backgroundColor: "red",
            display: "inline",
            border: "0px",
            minWidth: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px",
            cursor: "pointer",
          }}
          onClick={handleSearch}
        >
          <img
            width="30px"
            height="30px"
            src="./logo.svg"
            style={{ margin: "0px", padding: "5px" }}
          />
        </span>
      </div>

      {/* Mobile ui */}

      <div className="grid-container1-mob">
        <div
          style={{
            display: "inline",
            border: "1px solid #CCCCCC",
            borderRadius: "5px",
            borderTopRightRadius: "0px",
            borderBottomRightRadius: "0px",
            padding: "0px 5px",
          }}
          className="grid-container auto-complete"
        >
          <div class="find">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={cussionSuggestions}
              value={state}
              onChange={(e, val) => handleChange1(val)}
              filterSelectedOptions
              getOptionLabel={(option) => option}
              class="auto1"
              sx={{ width: 300 }}
              clearOnEscape={true}
              renderInput={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                    zIndex: 1,
                    width: "100%",
                    textAlign: "left",
                  }}
                >

                  <TextField
                    {...item}
                    label="Find"
                    variant="standard"
                    class="textfield-mob"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              )}
            />
          </div>

          <div class="near">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={suggestions}
              value={location}
              clearOnEscape={true}
              getOptionLabel={(option) => option}
              filterSelectedOptions
              onChange={(e, val) => handleChange(val)}
              class="auto2"
              sx={{ width: 300 }}
              renderInput={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                    zIndex: 1,
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <TextField
                    {...item}
                    label="Near"
                    variant="standard"
                    class="textfield-mob"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <div class="mob-search">
        <span
          style={{
            backgroundColor: "red",
            display: "inline",
            border: "0px",
            maxWidth: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px",
            cursor: "pointer",
          }}
          onClick={handleSearch}
        >
          <img
            width="30px"
            height="30px"
            src="./search.svg"
            style={{ margin: "0px", padding: "5px" }}
          />
        </span>
      </div>

      {console.log(list, "list")}
      {list.length > 0 ? (
        list.map((brand) => (
          <Link
            key={brand.id}
            to={brand.brandPath}
            className="brand-page--brand"
            style={{ zIndex: 0 }}
          >
            <img
              src={brand?.logo?.localFile?.publicURL}
              style={{ zIndex: -5 }}
            />
            <span>{brand.brandName}</span>
          </Link>
        ))
      ) : (
        <div style={{ marginTop: "20px" }}>No Record Found</div>
      )}
    </div>
  );
}

const IndexPage = (props) => {
  return (
    <Layout>
      <SEO title="SideDoor Search" />
      <img src="/sidedoor-search-logo.svg" className="sidedoor-search-logo" />
      <h1 style={{ margin: `80px 0` }}>
        Order food from trending <span>delivery-only</span> restaurants
      </h1>

      <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
        <Image />
      </div>

      <div style={{ textAlign: `center` }}>
        <Component query={props?.data?.allStrapiBrands?.nodes} />
      </div>

      <div></div>
      <footer
        style={{ textAlign: "center", padding: "15px", marginTop: "30px" }}
      >
        © {new Date().getFullYear()} SideDoor
      </footer>
    </Layout>
  );
};

export const query = graphql`
  query HomePageQuery {
    allStrapiBrands {
      nodes {
        brandColor
        brandName
        brandStory
        brandPath
        brandTag
        order
        concepts {
          title
        }
        cuisines {
          name
        }
        locations {
          location {
            state
            city
          }
        }
        coverPicture {
          localFile {
            publicURL
          }
        }
        icon {
          localFile {
            publicURL
          }
        }
        logo {
          localFile {
            publicURL
          }
        }
      }
    }
  }
`;

export default IndexPage;
